import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export function NotificationBell() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["me", "notifications"], refetchInterval: 60000, queryFn: () => api.get("/me/notifications").then((r) => r.data) });
  const unread = data?.unread || 0;
  const markRead = async (open) => {
    if (!open && unread) { await api.post("/me/notifications/read"); qc.invalidateQueries({ queryKey: ["me", "notifications"] }); }
  };
  return (
    <DropdownMenu onOpenChange={markRead}>
      <DropdownMenuTrigger asChild>
        <button className="btn-ghost relative px-2" aria-label="Notifications" data-testid="notification-bell">
          <Bell className="h-5 w-5 text-amber-200" />
          {unread > 0 && <span className="absolute -right-0.5 -top-0.5 rounded-full bg-aether-500 px-1.5 text-[10px] font-bold text-[#0A1222]" data-testid="notification-unread-count">{unread}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-96 w-80 overflow-y-auto border-[#2A3447] bg-[#121620] text-slate-200" data-testid="notification-list">
        <DropdownMenuLabel>Notifications</DropdownMenuLabel>
        {data?.items.length ? data.items.map((n) => (
          <DropdownMenuItem key={n.notification_id} onClick={() => navigate(n.link)} className={`flex-col items-start gap-0.5 ${n.read ? "opacity-70" : ""}`} data-testid={`notification-${n.notification_id}`}>
            <span className="text-sm">{n.title}</span><span className="font-mono text-[10px] text-slate-500">{n.kind} · {n.created_at.slice(0, 16).replace("T", " ")}</span>
          </DropdownMenuItem>
        )) : <p className="px-2 py-3 text-xs text-slate-500">No notifications yet.</p>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
